function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as c } from "react/jsx-runtime";
import { useFieldProps as x } from "./form-context.js";
import { useTheme as F } from "./hooks.js";
import { TextFieldBaseAutosuggest as v } from "./text-field-base.js";
const T = (_param)=>{
    var { inputRef: u , value: r , defaultValue: n  } = _param, i = _object_without_properties(_param, [
        "inputRef",
        "value",
        "defaultValue"
    ]);
    const t = (e)=>String(e !== null && e !== void 0 ? e : "").replace(/[^\d]/g, "");
    return /* @__PURE__ */ c("input", _object_spread_props(_object_spread({}, i), {
        inputMode: "numeric",
        pattern: "[0-9]*",
        onInput: (e)=>{
            e.currentTarget.value = t(e.currentTarget.value);
        },
        ref: u,
        type: "text",
        value: r === void 0 ? void 0 : t(r),
        defaultValue: n === void 0 ? void 0 : t(n)
    }));
}, h = (_param)=>{
    var { disabled: u , error: r , helperText: n , name: i , optional: t , validate: o , onChange: e , onChangeValue: d , onBlur: p , value: m , defaultValue: a  } = _param, l = _object_without_properties(_param, [
        "disabled",
        "error",
        "helperText",
        "name",
        "optional",
        "validate",
        "onChange",
        "onChangeValue",
        "onBlur",
        "value",
        "defaultValue"
    ]);
    const { texts: f  } = F(), g = x({
        name: i,
        value: m,
        defaultValue: a,
        processValue: (s)=>s.trim(),
        helperText: n,
        optional: t,
        error: r,
        disabled: u,
        onBlur: p,
        validate: (s, I)=>s ? o == null ? void 0 : o(s, I) : t ? "" : f.formFieldErrorIsMandatory,
        onChange: e,
        onChangeValue: d
    });
    return /* @__PURE__ */ c(v, _object_spread_props(_object_spread({}, l, g), {
        inputComponent: T
    }));
}, C = h;
export { T as IntegerInput, C as default };
